export class Stopwatch {
  constructor(fn, interval = 1000) {
    this.interval = interval
    this.isStop = false
    this.runFn = fn
    this.timeoutFnId = null
    this.start()
    return this
  }
  start() {
    if (!this.runFn || this.isStop) {
      this.stop()
      return
    }
    this.timeoutFnId = setTimeout(() => {
      this.runFn()
      this.start()
    }, this.interval)
  }
  stop() {
    if (this.timeoutFnId) {
      clearTimeout(this.timeoutFnId)
    }
  }
}
